import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlowObjectDefinition } from '../models/flow-object.model';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FlowObjectDefinitionService extends BaseService {
    controllerRoute = 'FlowObjectDefinition';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async update(data: FlowObjectDefinition): Promise<IBaseModel<void>> {
        return await firstValueFrom(this.httpClient.put<IBaseModel<void>>(`${this.apiBaseUrl}/${this.controllerRoute}`, data));
    }

    public async previewFinalPdf(data: any): Promise<IBaseModel<string>> {
        return await firstValueFrom(this.httpClient.post<IBaseModel<string>>(`${this.apiBaseUrl}/${this.controllerRoute}/PreviewFinalPdf`, data));
    }

    public async getFormSchema(id: string): Promise<IBaseModel<string>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<string>>(`${this.apiBaseUrl}/${this.controllerRoute}/GetFormSchema/${id}`));
    }
}
